import {FC, useCallback, useEffect, useMemo, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {useContact} from '../../../../../hooks/useContact'
import InsertNewData from '../../../../../Components/InsertNewData'
import {Spinner} from 'react-bootstrap'
import ContactListPanel from '../../Components/ContactListPanel'
import {DeleteContactsParams, Group, Tag} from '../../../../../../services/cellcast.v2.types'
import {toast} from 'react-toastify'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import {useLazyContactDetailListQuery} from '../../../../../../services/cellcast.v2'
import {GetContectData} from '../../AllContactsList/SubscriberSlice/SubscriberSlice'
import {useDispatch, useSelector} from 'react-redux'
import ContectDataModel from '../../../../../Components/ContectDataModel'
import {ContactGroupMap} from '../../../../../../services/cellcast.v2.types'
import EditSingleSubscriber from '../../AllContactsList/Modal/EditSingleSubscriber'
import AssignedTags from '../../AllContactsList/Modal/AssignedTags'
import DeleteConfirmationPopup from '../../../../../Components/DeleteConfirmationPopup'
import QuickMessageDrawerInner from '../../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {useGetAllTagsQuery} from '../../../../../../services/cellcast'
import UploadContact from '../../Components/UploadContactModal'
import ContactDetailPanel from '../../Components/ContactDetailPanel'
import {getIsDefaultRegion} from '../../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import AddSingleSubscriber from '../../AllContactsList/Modal/AddSingleSubscriber'

export type DetailPageProps = {}
const DetailPage: FC = () => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const {id} = useParams()

  // Api Fetching Hook
  const {loading, data, actions} = useContact('DetailPage', false, {
    staticTag: id,
  })
  const [getDetail, {data: listData, isLoading: detailLoading, isFetching: detailFetching}] =
    useLazyContactDetailListQuery()
  // load all tag
  const {isLoading: tagLoading, data: tagsData} = useGetAllTagsQuery(null)

  // Local state
  const [selectedContactGroupIDs, setSelectedContactGroupIDs] = useState<string[]>([])
  const [selectedContactIDs, setSelectedContactIDs] = useState<string[]>([])
  const [showAddModal, setShowAddModal] = useState(false)
  const [showReSubscribeModal, setShowReSubscribeModal] = useState(false)
  const [showDetailModal, setShowDetailModal] = useState(false)
  const [editModal, setEditModal] = useState<{
    data: any
    toggle: boolean
    number?: string
    _id?: string
    tags: Tag[]
    group?: Group
  }>({
    data: '',
    toggle: false,
    tags: [],
  })

  const [addModal, setAddModal] = useState<{
    data: any
    toggle: boolean
    group?: Group
  }>({
    data: '',
    toggle: false,
  })

  const [showQmDrawer, setShowQmDrawer] = useState(false)
  const [showAddTagModal, setShowAddTagModal] = useState(false)
  const [showUnsubscribeConfirmation, setShowUnsubscribeConfirmation] = useState(false)
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [selectedDetailId, setSelectedDetailId] = useState('')

  // action
  const handleShowDetailModal = (number: string, contactId: string) => {
    setSelectedDetailId(contactId)
    setShowDetailModal(true)
  }

  const handleShowEditModal = (data: ContactGroupMap) => {
    const mergedArray = data && data.group && data.group.fields ? [...data.group.fields] : []

    const finalFieldData = mergedArray.map((key) => {
      if (data?.fields?.find((field) => field.name === key) !== undefined) {
        return data?.fields?.find((field) => field?.name === key)
      } else {
        return {name: key, value: ''}
      }
    })
    setEditModal({
      data: finalFieldData,
      toggle: true,
      number: data?.number,
      _id: data?._id,
      tags: data?.tags,
      group: data.group,
    })
  }

  const handleChangSizeData = (size: number) => {
    actions.setParams({...data.params, limit: size, page: ''})
    actions.setTriggerFetch()
  }

  const handleSetSort = (sortKey: string, sortValue: string) => {
    actions.setParams({...data.params, sortKey: sortKey, sortValue: sortValue})
    actions.setTriggerFetch()
  }

  const handleSubscribe = useCallback(
    (contactIDs: string[]) => {
      let payload: any = {contactIDs: contactIDs}

      if (!isDefaultRegion) {
        payload = {
          is_subscribe: true,
          ids: contactIDs,
        }
      }

      actions
        .subscribe(payload)
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error subscribe:', res.error)
          }
          actions.setTriggerFetch()
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [actions]
  )

  const handleUnsubscribe = useCallback((contactIDs: string[]) => {
    setSelectedContactIDs(contactIDs)
    setShowUnsubscribeConfirmation(true)
  }, [])

  const handleDoFetchData = useCallback(
    (fetchGroup: boolean) => {
      if (fetchGroup) {
        actions.setTriggerFetchGroup(true)
      }
      actions.setParams({...data.params, page: ''})
      actions.setTriggerFetch()
    },
    [actions, data.params]
  )

  const handleChangePage = useCallback(
    (page: number | null, next: boolean) => {
      if (page === null || loading.contactFetch || loading.contactLoad) {
        return
      }

      if (next) {
        actions.setParams({...data.params, page: page})
        actions.setTriggerFetchNext()
      } else {
        actions.setParams({...data.params, page: page})
        actions.setTriggerFetchPrev()
      }
    },
    [actions, data.params]
  )

  const handleExports = useCallback(() => {
    actions
      .exportContact({
        query: data.params,
        body: {
          contactIDs: selectedContactGroupIDs.length > 0 ? selectedContactGroupIDs : [],
        },
      })
      .then((res) => {
        if ('data' in res) {
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
          window.open(`${API_DOMAIN}${res.data?.data.downloadurl}`, '_self')
        } else if ('error' in res) {
          toast.error(res.error)
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
          console.error('Error export:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
        setSelectedContactIDs([])
        setSelectedContactGroupIDs([])
      })
  }, [API_DOMAIN, actions, selectedContactGroupIDs])

  const handleShowBm = useCallback(() => {
    if (selectedContactGroupIDs?.length > 0) {
      navigate(`/new-message`, {
        state: {
          selectedType: 'contacts',
          data: data.contacts
            .filter((key: ContactGroupMap) => selectedContactGroupIDs?.includes(key?._id))
            ?.map((key: any) => key?.number),
        },
      })
    } else {
      navigate(`/new-message`, {
        state: {
          selectedType: 'segmentOrTags',
          data: `tag_${id}`,
        },
      })
    }
  }, [data.contacts, id, navigate, selectedContactGroupIDs])

  useEffect(() => {
    if (id && id.length > 0) {
      getDetail(id)
      actions.setParams({
        ...data.params,
        page: 1,
        limit: 10,
        tag: id,
      })
      actions.setTriggerFetch()
    }
  }, [id])

  // Modal
  const ContactDetail = useMemo(
    () => (
      <ContactDetailPanel
        show={showDetailModal}
        handleClose={() => {
          setShowDetailModal(false)
          setSelectedDetailId('')
        }}
        setEditPopup={setEditModal}
        contactId={selectedDetailId}
        group={data?.group?.data}
      />
    ),
    [showDetailModal]
  )

  const EditContact = useMemo(
    () => (
      <EditSingleSubscriber
        show={editModal}
        handleClose={setEditModal}
        callbackFn={() => {
          actions.setTriggerFetch()
          setSelectedContactGroupIDs([])
          setSelectedContactIDs([])
        }}
      />
    ),
    [actions, editModal, id]
  )

  const AddTagModal = useMemo(
    () => (
      <AssignedTags
        checkList={selectedContactGroupIDs}
        show={showAddTagModal}
        handleClose={() => setShowAddTagModal(false)}
        callbackFn={() => {
          actions.setTriggerFetch()
          setSelectedContactGroupIDs([])
          setSelectedContactIDs([])
        }}
      />
    ),
    [showAddTagModal, selectedContactGroupIDs]
  )

  const UnsubscribeConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={showUnsubscribeConfirmation}
        handleClose={() => {
          setShowUnsubscribeConfirmation(false)
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
        }}
        Message={'Are you sure, you want to unsubscribe contact ?'}
        confirm={() => {
          if (selectedContactIDs && selectedContactIDs.length > 0) {
            let payload: any = {contactIDs: selectedContactIDs}
            if (!isDefaultRegion) {
              payload = {
                is_subscribe: false,
                ids: selectedContactIDs,
              }
            }

            actions
              .unsubscribe(payload)
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error unsubscribe:', res.error)
                }
                actions.setTriggerFetch()
                setSelectedContactIDs([])
                setSelectedContactGroupIDs([])
              })
              .catch((err) => {
                toast.error(err.error)
              })
            setShowUnsubscribeConfirmation(false)
          }
        }}
        confirmBtnTitle='Yes, unsubscribe'
      />
    ),
    [showUnsubscribeConfirmation, selectedContactIDs, actions]
  )

  const DeleteContact = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={showDeleteConfirmation}
        handleClose={() => {
          setShowDeleteConfirmation(false)
          setSelectedContactIDs([])
          setSelectedContactGroupIDs([])
        }}
        Message={
          selectedContactGroupIDs?.length
            ? `Are you sure, you want to delete ${
                selectedContactGroupIDs?.length
                  ? `${selectedContactGroupIDs.length} selected`
                  : 'all'
              } contact?`
            : `To confirm that you want to delete all contacts and data from your account, please type "DELETE" in the field provided below`
        }
        confirm={() => {
          let params: any = {
            query: data.params,
            body: {
              contactIDs: selectedContactGroupIDs,
              allContact: false,
            },
          }

          let isUseFilter = false
          if (!isUseFilter && data.params.tag && data.params.tag.length > 0) {
            isUseFilter = true
          }

          if (!isUseFilter && data.params.excludeTag && data.params.excludeTag.length > 0) {
            isUseFilter = true
          }

          if (!isUseFilter && data.params.search && data.params.search.length > 0) {
            isUseFilter = true
          }

          if (!isUseFilter && data.params.status && data.params.status.length > 0) {
            isUseFilter = true
          }

          if (isUseFilter === false && selectedContactGroupIDs.length === 0) {
            params.body.allContact = true
          }

          if (!isDefaultRegion) {
            params = {
              ids: selectedContactGroupIDs,
            }

            if (!selectedContactGroupIDs?.length) {
              params['is_delete_all'] = true
            }
          }

          actions
            .deleteContact(params)
            .then((res) => {
              if ('data' in res) {
                toast.success(res.data?.message)
              } else if ('error' in res) {
                toast.error(res?.error)
                console.error('Error delete contact:', res?.error)
              }
              actions.setTriggerFetch()
              setSelectedContactIDs([])
              setSelectedContactGroupIDs([])
            })
            .catch((err) => {
              toast.error(err.error)
            })
        }}
        subTitle={'These contacts and all data will be permanently deleted from your account.'}
        withInputConfirmation={selectedContactGroupIDs.length < 1}
      />
    ),
    [actions, data.group, selectedContactGroupIDs, showDeleteConfirmation]
  )

  const handleShowAddSingleContact = useCallback(() => {
    const mergedArray = data.group && data.group.data?.fields ? [...data.group.data?.fields] : []

    setAddModal({
      data: mergedArray.map((it) => ({name: it, value: ''})),
      toggle: true,
      group: data.group?.data as any,
    })
  }, [data.group])

  const SendQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        show={showQmDrawer}
        handleClose={() => setShowQmDrawer(false)}
        contacts={
          data.contacts.length > 0
            ? data.contacts
                .filter((key: any) => selectedContactGroupIDs?.includes(key?._id))
                .map((key: any) => ({value: key?.number, label: key?.number}))
            : []
        }
      />
    ),
    [selectedContactGroupIDs, showQmDrawer]
  )

  const Import = useMemo(
    () => (
      <UploadContact
        show={showAddModal}
        listName={(listData && listData.data && listData.data.name) || ''}
        groupId={data.group && data.group.data ? data.group.data._id : ''}
        handleClose={() => {
          setShowAddModal(false)
        }}
        listId={id}
        showAddSingleContact={handleShowAddSingleContact}
      />
    ),
    [showAddModal, listData, data.group, id]
  )

  const AddSingleContact = useMemo(
    () => (
      <AddSingleSubscriber
        show={addModal}
        handleClose={setAddModal}
        callbackFn={() => {
          actions.setTriggerFetch()
          setSelectedContactGroupIDs([])
          setSelectedContactIDs([])
        }}
        tagIds={[id]}
      />
    ),
    [actions, addModal]
  )

  return (
    <>
      {AddSingleContact}
      {ContactDetail}
      {EditContact}
      {DeleteContact}
      {AddTagModal}
      {UnsubscribeConfirmation}
      {SendQuickMessage}
      {Import}
      {!loading.groupLoad &&
        !detailLoading &&
        !detailFetching &&
        !tagLoading &&
        (!data.group || !data.group.data || (data.group && !data.group.data._id)) && (
          <InsertNewData
            message={{
              title: `You don't have any contacts yet`,
              subtitle: `Easily add your contacts by uploading your list or add your contacts by copying and pasting`,
            }}
            buttonName={{
              name: 'Add contacts',
              link: '',
              popup: true,
              buttonFun: () => {}, // TODO : Open import
            }}
          />
        )}
      {(loading.groupLoad || detailFetching || detailLoading || tagLoading) && (
        <div className='row flex-center h-200'>
          <Spinner />
        </div>
      )}

      {!loading.groupLoad &&
        !detailLoading &&
        !detailFetching &&
        !tagLoading &&
        data.group &&
        data.group.data &&
        data.group.data._id && (
          <ContactListPanel
            groupId={data.group && data.group.data ? data.group.data._id : ''}
            contacts={data.contacts}
            groupField={
              data.group && data.group.data && data.group.data.fields ? data.group.data.fields : []
            }
            totalData={data.totalContacts}
            loadedData={data.loadedContact}
            params={data.params}
            setParams={actions.setParams}
            isFetchLoading={loading.contactFetch}
            isLoading={loading.contactLoad}
            isCountLoading={loading.contactCountLoading}
            isFetchCountLoading={loading.contactCountFetching}
            isLoadingExport={loading.export}
            isDeleteLoading={loading.contactDelete}
            next={data.next}
            prev={data.prev}
            tags={
              tagsData && tagsData.data ? tagsData.data.filter((el: any) => el.type !== 'list') : []
            }
            tagID={id}
            doFetchData={handleDoFetchData}
            handleChangSizeData={handleChangSizeData}
            handleDelete={() => setShowDeleteConfirmation(true)}
            handleExport={() => handleExports()}
            handleShowDetailContact={handleShowDetailModal}
            handleShowAddContactModal={setShowAddModal}
            handleShowAddSingleContact={handleShowAddSingleContact}
            handleShowEditContact={handleShowEditModal}
            handleShowReSubscribeContactModal={setShowReSubscribeModal}
            handleShowAttachTagModal={setShowAddTagModal}
            handleShowQmDrawer={setShowQmDrawer}
            handleShowBm={handleShowBm}
            handleSubscribe={handleSubscribe}
            handleUnsubscribe={handleUnsubscribe}
            selectedContactIDs={selectedContactIDs}
            setSelectedContactIDs={setSelectedContactIDs}
            handleChangePage={handleChangePage}
            handleSetSort={handleSetSort}
            isLoadingSubAndUnSub={loading.unsubscribe || loading.subscribe}
            selectedContactGroupIDs={selectedContactGroupIDs}
            setSelectedContactGroupIDs={setSelectedContactGroupIDs}
            showFilterTag={true}
            showDeleteContactList={true}
            showSendMessageAction={true}
            showSubscribeStatus={false}
            showTag={true}
            Header={
              <div className='d-flex flex-column w-100 mb-5'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>
                    All contact in {listData && listData.data && listData.data.name}
                  </span>
                </h3>
              </div>
            }
            showAddTag={false}
            showExport={isDefaultRegion ? true : false}
            showFilterField={isDefaultRegion ? true : false}
          />
        )}
    </>
  )
}

export default DetailPage
